// extracted by mini-css-extract-plugin
export default {"body":"PanelControl_body__rMICY","content":"PanelControl_content__wr9Tq","menuGroup":"PanelControl_menuGroup__FYrQq"};